import { createElement } from "@wordpress/element";

/**
 * External dependencies
 */
import { Icon } from '@wordpress/components';
export default (function () {
  return createElement(Icon, {
    icon: createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24"
    }, createElement("path", {
      fill: "#1E8CBE",
      d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
      /* eslint-disable-line max-len */

    }))
  });
});
//# sourceMappingURL=checkbox-checked.js.map